import { TripBucketMatches, TripBucketMatchesQuery } from '../../travel.js';
import { AddTripInput, UpdateTripInput, TripSaved, TripView, TripPage, TripQuery, DeleteTripQuery, TripDeleted, TravelProfile, AddBucketInput, UpdateBucketInput, BucketView, BucketPage, BucketQuery, TravelDeleted, BucketStepInput, UpdateBucketStepInput, } from '../../travel.js';
export const travelRoutes = {
    bucketMatches: {
        method: 'GET',
        path: '/me/trips/bucket-matches',
        query: TripBucketMatchesQuery,
        response: TripBucketMatches,
    },
    profile: { method: 'GET', path: '/users/:userId/profile/travel', response: TravelProfile },
    trips: {
        method: 'GET',
        path: '/users/:userId/profile/trips',
        query: TripQuery,
        response: TripPage,
    },
    trip: { method: 'GET', path: '/users/:userId/profile/trips/:id', response: TripView },
    addTrip: { method: 'POST', path: '/me/trips', body: AddTripInput, response: TripSaved },
    updateTrip: {
        method: 'PATCH',
        path: '/me/trips/:id',
        body: UpdateTripInput,
        response: TripSaved,
    },
    deleteTrip: {
        method: 'DELETE',
        path: '/me/trips/:id',
        query: DeleteTripQuery,
        response: TripDeleted,
    },
    bucket: {
        method: 'GET',
        path: '/users/:userId/profile/bucket',
        query: BucketQuery,
        response: BucketPage,
    },
    dream: { method: 'GET', path: '/users/:userId/profile/bucket/:id', response: BucketView },
    addDream: { method: 'POST', path: '/me/bucket', body: AddBucketInput, response: BucketView },
    updateDream: {
        method: 'PATCH',
        path: '/me/bucket/:id',
        body: UpdateBucketInput,
        response: BucketView,
    },
    deleteDream: { method: 'DELETE', path: '/me/bucket/:id', response: TravelDeleted },
    achieve: { method: 'POST', path: '/me/bucket/:id/achieve', response: BucketView },
    undoAchieve: { method: 'DELETE', path: '/me/bucket/:id/achieve', response: BucketView },
    addStep: {
        method: 'POST',
        path: '/me/bucket/:id/steps',
        body: BucketStepInput,
        response: BucketView,
    },
    updateStep: {
        method: 'PATCH',
        path: '/me/bucket/:id/steps/:stepId',
        body: UpdateBucketStepInput,
        response: BucketView,
    },
    deleteStep: { method: 'DELETE', path: '/me/bucket/:id/steps/:stepId', response: BucketView },
    shareDream: { method: 'POST', path: '/me/bucket/:id/share', response: BucketView },
};
//# sourceMappingURL=travel-routes.js.map